<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmiana parametrów wysyłki
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="address.orderAddress.carrier"
                            :items="couriers"
                            label="Przewoźnik"
                            return-object
                            item-value="id"
                            item-text="shortCode"
                            outlined
                            hide-details
                            no-data-text="Nie znaleziono przewoźnika"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="updateSending"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CourierDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        addressData: {
            type: Object,
            default: null
        },
        couriers: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            address: {
                orderAddress: {
                    carrier: {},
                }
            }
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.address = JSON.parse(JSON.stringify(this.addressData))
            }
        }
    },
    methods: {
        updateSending() {
            this.$emit('update-sending', JSON.parse(JSON.stringify(this.address)))
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.address = JSON.parse(JSON.stringify(this.addressData))
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>